import { render, staticRenderFns } from "./ListadoSolicitudesInscripcionesPaginados.vue?vue&type=template&id=0c176132"
import script from "./ListadoSolicitudesInscripcionesPaginados.vue?vue&type=script&lang=js"
export * from "./ListadoSolicitudesInscripcionesPaginados.vue?vue&type=script&lang=js"
import style0 from "./ListadoSolicitudesInscripcionesPaginados.vue?vue&type=style&index=0&id=0c176132&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports